import {Divider, ListItemIcon, ListItemText, MenuItem} from '@mui/material';
import {Gear, SignIn, UserPlus} from '@phosphor-icons/react';
import {messages} from '@smartmixin/i18n';
import React from 'react';
import {useIntl} from 'react-intl';
import {useLocation} from 'react-router';
import RouterLink from '../../../lib/RouterLink';

const UnauthenticatedContent = () => {
  const {formatMessage} = useIntl();
  const location = useLocation();

  return (
    <React.Fragment>
      <MenuItem component={RouterLink} to="/app/settings">
        <ListItemIcon>
          <Gear />
        </ListItemIcon>
        <ListItemText primary={formatMessage(messages.settings.settings)} />
      </MenuItem>
      <Divider />
      <MenuItem
        component={RouterLink}
        to="/auth/login"
        state={{from: location}}>
        <ListItemIcon>
          <SignIn />
        </ListItemIcon>
        <ListItemText primary={formatMessage(messages.auth.login)} />
      </MenuItem>
      <MenuItem
        component={RouterLink}
        to="/auth/register"
        state={{from: location}}>
        <ListItemIcon>
          <UserPlus />
        </ListItemIcon>
        <ListItemText primary={formatMessage(messages.auth.register)} />
      </MenuItem>
    </React.Fragment>
  );
};

export default UnauthenticatedContent;
